


























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import EditOnClickField from '@/components/util/EditOnClickField.vue';
import { mapGetters } from 'vuex';
import { WorkordersApi } from 'performo-api';
import FloorPicker from '@/components/system/FloorPicker.vue';

@Component({
  components: { EditOnClickField, FloorPicker },
  computed: mapGetters({
    ordersApi: 'ordersApi'
  })
})
export default class FloorEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: false, type: String, default: 'Floor' })
  private label!: string;

  @Prop({ required: true, default: '' })
  private value!: string | number | undefined;

  @Prop({ required: false, default: undefined })
  private buildingCode!: string;

  private floorMode = 'read';

  private updatedValue: string | number | undefined = undefined;
  private loading!: boolean;

  private ordersApi!: WorkordersApi;

  data() {
    return { updatedValue: this.value, loading: false };
  }

  @Watch('buildingCode')
  private resetFloorValue() {
    this.valueUpdate = '';
  }

  get valueUpdate() {
    return this.updatedValue || this.value;
  }
  set valueUpdate(val) {
    this.updatedValue = val;
  }

  private async handleFloorChange(floor: string) {
    // update if we have an order
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === floor) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeLocation({
        workorderId: this.workorderId,
        changeOrderLocationCommand: {
          newFloor: floor,
          newLocation2: ''
        }
      });
      this.$emit('input', updated);
    } catch (error) {
      this.$emit('error', error);
    }

    // finally exit
    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.floorMode = 'read';
    this.loading = false;
  }
}
